import { AxiosResponse } from 'axios'
import { Toastr } from 'components/global/Toastr'
import { Action } from 'types/redux'
import * as actions from './actions'
import { SuggestedLinkResponse } from './actions'

export type ActionType = 'createComment' | 'deleteComment' | ''

type InitialStateType = {
  response: SuggestedLinkResponse
  fetching: boolean
}

const initialState: InitialStateType = {
  response: {
    data: [],
    org_total_links_count: 0,
    success: false,
    statusCode: 0,
  },
  fetching: false,
}

export default function reducer(
  state = initialState,
  action: Action<AxiosResponse<SuggestedLinkResponse>>,
): InitialStateType {
  switch (action.type) {
    case actions.GET_SUGGESTED_LINKS_PENDING: {
      return {
        ...state,
        response: {
          ...state.response,
          success: false,
        },
        fetching: true,
      }
    }

    case actions.GET_SUGGESTED_LINKS_FULFILLED: {
      return {
        ...state,
        response: action.payload?.data ?? initialState.response,
        fetching: false,
      }
    }

    case actions.GET_SUGGESTED_LINKS_REJECTED: {
      Toastr.error(action?.payload?.data.success)
      return {
        ...state,
        fetching: false,
      }
    }

    default:
      return state
  }
}
